import clsx from 'clsx';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { MBTextBody1 } from '@shared/components/typography';
import { Colors, grid } from '@shared/styles';
import styles from './List.module.css';

interface ListItemProps {
  label: string;
  icon?: MBIconV2Name;
  isSelected: boolean;
  onClick(): void;
  isDisabled?: boolean;
}

export function ListItem({ icon, label, isSelected, onClick, isDisabled }: ListItemProps) {
  return (
    <li className={clsx(styles.listItem, isDisabled && styles.disabled)}>
      <div
        onClick={onClick}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            flexBasis: `calc(100% - ${grid(3)}`,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: grid(4),
          }}
        >
          {!!icon && (
            <div style={{ display: 'flex', marginRight: grid(1) }}>
              <MBIconV2 color={Colors.v2.purple} name={icon || 'multi-line'} size={grid(3)} />
            </div>
          )}
          <MBTextBody1 color={Colors.v2.purple}>{label}</MBTextBody1>
        </div>
        {isSelected && (
          <div style={{ display: 'flex', flexBasis: grid(3) }}>
            <MBIconV2 color={Colors.v2.green} name="check-box" size={grid(3)} />
          </div>
        )}
      </div>
    </li>
  );
}
